import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, isAuthenticated } = useAuth();

  useEffect(() => {
    // Enhanced debug info logging
    console.log("❌ NotFound: Component mounted", {
      pathname: window.location.pathname,
      search: window.location.search,
      href: window.location.href,
      state: location.state,
      isAuthenticated,
      hasUser: !!currentUser,
      userRoles: currentUser?.roles?.map(r => r.name) || []
    });
    
    // Log a stack trace to see where this is coming from
    console.trace("NotFound component trace");
    
    // DISABLED: Auto-redirect to auth after delay
    // const timer = setTimeout(() => {
    //   console.log("🔍 NotFound: Auto-redirecting to /auth");
    //   navigate('/auth');
    // }, 3000);
    
    // return () => clearTimeout(timer);
  }, [navigate, location, isAuthenticated, currentUser]);

  const handleManualRedirect = (path) => {
    console.log(`🔍 NotFound: Manually redirecting to ${path}`);
    navigate(path);
  };

  return (
    <div className="container mt-5 text-center">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="card">
            <div className="card-body">
              <h1 className="display-1 text-danger">404</h1>
              <h2 className="mb-4">Page Not Found</h2>
              <p className="lead">
                The page you're looking for doesn't exist or you don't have permission to view it.
              </p>
              
              {isAuthenticated ? (
                <div className="alert alert-info">
                  You are currently authenticated as: {currentUser?.username || currentUser?.email || 'Unknown User'}
                </div>
              ) : (
                <div className="alert alert-warning">
                  You are not currently authenticated. You may need to log in.
                </div>
              )}
              
              <div className="mt-4">
                {!isAuthenticated && (
                  <button 
                    onClick={() => handleManualRedirect('/auth')}
                    className="btn btn-primary me-3"
                  >
                    Go to Login
                  </button>
                )}
                
                <button 
                  onClick={() => handleManualRedirect('/dashboard')}
                  className="btn btn-success me-3"
                >
                  Go to Dashboard
                </button>
                
                {isAuthenticated && (
                  <button 
                    onClick={() => handleManualRedirect('/courses')}
                    className="btn btn-info me-3"
                  >
                    Go to Courses
                  </button>
                )}
                
                <button 
                  onClick={() => handleManualRedirect('/')}
                  className="btn btn-outline-secondary"
                >
                  Go to Home
                </button>
                
                <button 
                  onClick={() => handleManualRedirect('/courses-direct')}
                  className="btn btn-warning me-3"
                >
                  Try Debug Courses
                </button>
              </div>
              
              <div className="card mt-4">
                <div className="card-header bg-info text-white">
                  Debugging Information
                </div>
                <div className="card-body">
                  <p>Current Path: {location.pathname}</p>
                  <p>Authentication: {isAuthenticated ? 'Yes' : 'No'}</p>
                  <p>User Roles: {currentUser?.roles?.map(r => r.name).join(', ') || 'None'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound; 